import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';


import Footter from './Component/Footter';


// import Checkpage from './Pages/vaccine/Checkpage';
// import Stuallpage from './Pages/vaccine/Stuallpage';
// import Tmm from './Pages/vaccine/Tmm';
// import Personnelpage from './Pages/vaccine/Personnelpage';
// import Report from './Pages/vaccine/Report';
import Homepage from './Pages/Homepage';
import Registerstudent from './Pages/register/Registerstudent';
import Registerauthorities from './Pages/register/Registerauthorities';
import Studentreport from './Pages/Student/Studentreport';
import Studentschoolreport from './Pages/Student/Studentschoolreport';
import Studentschoolreportconfirm from './Pages/Student/Studentschoolreportconfirm';
import Studentkpru from './Pages/Student/Studentkpru';
import StudentDropout from './Pages/Student/StudentDropout';
import StudentGraduate from './Pages/Student/StudentGraduate';
import Studentcurr from './Pages/Student/Studentcurr';
import Studentfinish from './Pages/Student/Studentfinish';
import Studentschoolmis from './Pages/Student/Studentschoolmis';
import Main from './Pages/Student/Main';
import Login from './Pages/Student/Login';
import StudentNotpaid from './Pages/Student/StudentNotpaid';
import Namelistall from './Pages/Student/Namelistall';





export default class Routes extends Component {
    render() {
        return (
            <>
            <Router basename="kprudashboard" >
                <>
                            <div >  
                            <Switch>
                            
                                <Route exact path="/" component={Login} />
                                <Route exact path="/login/:user1/:pass" component={Login} />
                                <Route exact path="/login" component={Login} />
                                <Route exact path="/StudentNotpaid" component={StudentNotpaid} />
                                 <Route exact path="/Namelistall" component={Namelistall} />
                                {/* <Route exact path="/Studentreport" component={Studentreport} />
                                <Route exact path="/Studentschoolreport" component={Studentschoolreport} />
                                <Route exact path="/Studentschoolreportconfirm" component={Studentschoolreportconfirm} />
                                <Route exact path="/Studentkpru" component={Studentkpru} />
                                <Route exact path="/StudentDropout" component={StudentDropout} />
                                <Route exact path="/StudentGraduate" component={StudentGraduate} />
                                <Route exact path="/Studentcurr" component={Studentcurr} />
                                <Route exact path="/Studentfinish" component={Studentfinish} />
                                // <Route exact path="/Studentschoolmis" component={Studentschoolmis} /> */}
                                <Route render={function () {return <h1>Not Found</h1> }} />
                            </Switch> 
                            </div>
               </>
      
            </Router>
           
          </>  
        )
    }
}
